import styled from "styled-components"

export const CarouselContainer = styled.div`
  width: 72px;
  height: 72px;
  overflow: hidden;
  position: relative;
  border-radius: 8px;
  flex-shrink: 0;
`

export const CarouselWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 17px;
  animation: slideImages 7.68s linear infinite;

  @keyframes slideImages {
    0% {
      transform: translateY(0);
    }
    18.75% {
      transform: translateY(0);
    }
    25% {
      transform: translateY(-89px);
    }
    43.75% {
      transform: translateY(-89px);
    }
    50% {
      transform: translateY(-178px);
    }
    68.75% {
      transform: translateY(-178px);
    }
    75% {
      transform: translateY(-267px);
    }
    93.75% {
      transform: translateY(-267px);
    }
    100% {
      transform: translateY(-356px);
    }
  }
`

export const FoodImage = styled.img`
  width: 72px;
  height: 72px;
  border-radius: 8px;
  flex-shrink: 0;
  object-fit: cover;
  object-position: center;
  display: block;
`
